export enum AppDataSources {
    SW,
    APP_ANNIE,
    PREMIUM_PLUS,
}
